import { Loader2, Check, RefreshCw, AlertTriangle } from 'lucide-react';

// Health-check badge shown next to each detected EHR card.
// Reflects the real-time content-script availability in that EHR tab.
export function HealthBadge({ health, isTebra }) {
  if (isTebra) return null;
  if (!health || health === 'checking') {
    return (
      <span className="inline-flex items-center gap-1 text-[9px] font-bold bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded-full" title="Checking EHR tab…">
        <Loader2 className="w-2.5 h-2.5 animate-spin" />
      </span>
    );
  }
  if (health === 'ready') {
    return (
      <span className="inline-flex items-center gap-1 text-[9px] font-bold bg-green-100 text-green-700 px-1.5 py-0.5 rounded-full uppercase tracking-wider" title="Extension connected — push will work">
        <Check className="w-2.5 h-2.5" /> Ready
      </span>
    );
  }
  if (health === 'needs-refresh') {
    return (
      <span className="inline-flex items-center gap-1 text-[9px] font-bold bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full uppercase tracking-wider" title="Refresh this EHR tab (Ctrl/⌘+R) before pushing">
        <RefreshCw className="w-2.5 h-2.5" /> Refresh
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 text-[9px] font-bold bg-red-100 text-red-700 px-1.5 py-0.5 rounded-full uppercase tracking-wider" title="Extension can't reach this tab">
      <AlertTriangle className="w-2.5 h-2.5" /> Offline
    </span>
  );
}
